import { Year, DefaultYearProps } from './../models/YearModell';
import Glim from "../models/GeneralLedgerInvoiceMirror";
import Vue from "vue";
import api from "../services/api";
import busyIndication from "@/utils/busyIndication";
import { Period, SelectablePeriod } from "../models/PeriodModell";
import { StatusChanged } from "../models/StatusChange";
import eventBus from "@/services/eventBus";
import {
  DetailedType,
  DimCodeActivity,
  DimCodeType,
  DimSort,
  MainType,
} from "../models/TypesForEdit";
import { Dimension } from "../models/dimension";
import AccountNumberTreeNode from "../models/invoiceMirrorTreeNode";
import { t } from "@/plugins/i18n";

export class GeneralLedgerStore {
  glims: Glim[] = [];
  invMirrorTrees: AccountNumberTreeNode[] = [];

  openedTreeItems: number[] = [];

  periods: Period[] = [];
  periodSelectables: SelectablePeriod[] = [
    { name: t("GeneralLedger_Negyedev"), value: 3 },
    { name: t("GeneralLedger_Felev"), value: 6 },
    { name: t("Ev"), value: 12 },
    { name: t("GeneralLedger_Ev1"), value: 13 },
  ];

  years: Year[] = [];
  createdYear: Year = DefaultYearProps;

  statuses: string[] = [];
  statusesMin: string[] = [
    t("ElokeszitesAlatt"),
    t("GeneralLedger_KonyvelesreNyitott"),
    t("GeneralLedger_VeglegLezart"),
  ];

  yearBeingChecked = 0;
  hasGlimGenerated = false;
  hasGlimByNature = false;

  mainTypes: MainType[] = [];
  detailedTypes: DetailedType[] = [];
  dimSortTypes: DimSort[] = [];
  dimCodeTypes: DimCodeType[] = [];
  dimActivities: DimCodeActivity[] = [];

  dimensions: Dimension[] = [];


  @busyIndication()
  async generateDims() {
    await api
      .GenerateDimensionsByYearId(this.yearBeingChecked)
      .then((result) => {
        console.log(result)
        if (result) {
          eventBus.$emit("success", t("SikeresGeneralas"));
        } else {
          eventBus.$emit("error", t("GeneralLedger_AGeneralasSikertelenVolt"));
        }
      });
  }

  async SetMainTypes(){
    this.mainTypes= await api.GetMainTypes();
  }

  async SetDetailedTypes(){
    this.detailedTypes= await api.GetDetailedTypes();
  }

  async GetDimSortTypes(){
    this.dimSortTypes=await api.GetDimSortTypes();
  }

  async DeleteDimensions(dimensionIds: number[]) {
    const result = await api.DeleteDimensions(dimensionIds);
    if (result) {
      eventBus.$emit("success", t("GeneralLedger_AKivalasztottDimenziokSikeresenTorolve"));
    } else {
      eventBus.$emit("error", t("GeneralLedger_AKivalasztottDimenziokTorleseNemSikerult"));
    }
  }

  async CreateInvMirror(invMirror: Glim) {
    const result = await api.CreateInvMirror(invMirror);
    if (result!="") {
      eventBus.$emit("success", t("GeneralLedger_FokonyviSzamlaSikeresenLetrehozva"));
      eventBus.$emit("success", result);
      eventBus.$emit("api-search-page:refresh")
    } else {
      eventBus.$emit("success", t("GeneralLedger_FokonyviSzamlaSikeresenLetrehozva"));
    }
  }

  @busyIndication()
  async setGlims() {
    this.glims = await api.GetGeneralLedgerInvoiceMirrors();
  }
  @busyIndication()
  async setYears() {
    this.years = await api.GetGeneralLedgerYears();
  }
  @busyIndication()
  async setPeriods(yearId: number) {
    this.periods = await api.GetPeriods(yearId);
  }

  async setStatuses() {
    this.statuses = await api.GetStatuses();
  }

  async setDimActivities() {
    this.dimActivities = await api.GetDimActivities();
  }

  async saveYear() {
    await api.SaveYear(this.createdYear);
  }

  async saveStatus(item: StatusChanged[]) {
    await api.SaveStatus(item);
  }
  async saveGlimStatusChanges(glims: Glim[]) {
    return await api.UpdateGlimStatuses(glims);
  }

  async setDimCodeTypes() {
    this.dimCodeTypes = await api.GetDimCodeTypes();
  }

  async saveDimStatusChanges(changedDimStatuses: Dimension[]) {
    return await api.UpdateDimStatuses(changedDimStatuses);
  }

  async saveGlimEdits(invMirror: Glim){
    const result = await api.UpdateGlim(invMirror);
    if (result) {
      eventBus.$emit("success", t("GeneralLedger_SikeresenMentve"));
    } else {
      eventBus.$emit("error", t("GeneralLedger_AMentesNemSikerult"));
    }
  }



  @busyIndication()
  async getInvMirrorTree(yearId: number){
    this.invMirrorTrees = await api.GetInvMirrorTree(yearId);
  }

  saveDimEdits(dim: Dimension) {
    api.UpdateDim(dim).then((x) => {
      if (x) {
        eventBus.$emit("success", t("GeneralLedger_DimenzoKodSikeresenModositva"));
      } else {
        eventBus.$emit("error", t("GeneralLedger_HibaLepettFelAModositasKozben"));
      }
    });
  }

  @busyIndication()
  async getOpenTreeItems(yearId: number){
    this.openedTreeItems = await api.getOpenTreeItems(yearId);
  }

  @busyIndication()
  async generateInvMirrors() {
      this.hasGlimGenerated = true;
      eventBus.$emit("successs", t("SikeresGeneralas"));
      eventBus.$emit("api-pager:set-page", 1);
  }

  saveGeneratedGlims() {
    api.CreateGeneratedGlims(this.glims);
  }

  @busyIndication()
  async DeleteGlims(itemIds: number[]): Promise<boolean> {
    const success = await api.DeleteGlims(itemIds);
    if (success) {
      eventBus.$emit("success", t("SikeresMentes"));
    } else {
      eventBus.$emit("error", t("GeneralLedger_SikertelenVoltAMentes"));
    }
    return success;
  }

}

const store = Vue.observable(new GeneralLedgerStore());
export default store;
